import React from 'react'

import { Button, Dialog, Divider, Heading, Input, Text } from '@plurall/elo-beta'
import { renderValidationText } from 'App/views/PersonalData/utils/functions'

import styles from './ResponsibleLinkStudentModal.module.scss'

interface IResponsibleLinkStudentModalProps {
  onClose: () => void
  onInputChange: () => void
  onSubmit: () => void
  isLoading: boolean
  validation: string
}

const ResponsibleLinkStudentModal = ({
  onClose,
  onInputChange,
  onSubmit,
  isLoading,
  validation,
}: IResponsibleLinkStudentModalProps) => (
  <Dialog
    title='Vincular aluno'
    onClose={onClose}
    dataTestId='responsible-link-student-modal-dialog'
  >
    <Text size='t2' dataTestId='responsible-link-student-modal-input-text'>
      Digite o código de vínculo do aluno
    </Text>
    <div className={styles['input-container']}>
      <Input
        onChange={onInputChange}
        maxLength={10}
        dataTestId='responsible-link-student-modal-input'
        placeholder='Ex: 12345ABCDE'
        className={styles.input}
        disabled={isLoading}
        {...renderValidationText(validation, 'negative', validation)}
      />

      <Button
        onClick={onSubmit}
        secondary
        dataTestId='responsible-link-student-modal-valid-button'
        className={styles['valid-button']}
        loading={isLoading}
      >
        Validar
      </Button>
    </div>

    <Divider light />

    <section className={styles['instructions-container']}>
      <Heading element='h4' dataTestId='responsible-link-student-modal-help-heading'>
        Onde localizar código de vínculo do aluno?
      </Heading>

      <Text size='t2' dimmed dataTestId='responsible-link-student-modal-help-text-1'>
        1. Acesse a conta do aluno ou peça para ele fazer o login no Plurall.
      </Text>
      <Text size='t2' dimmed dataTestId='responsible-link-student-modal-help-text-2'>
        2. Clique em "Meu Perfil" e, depois, em "Dados pessoais e acesso".
      </Text>
      <Text size='t2' dimmed dataTestId='responsible-link-student-modal-help-text-3'>
        3. Localize e anote o código de vínculo.
      </Text>
      <Text size='t2' dimmed dataTestId='responsible-link-student-modal-help-text-4'>
        4. Digite o código de vínculo do aluno e clique em "Validar".
      </Text>
    </section>

    <img
      className={styles.image}
      src={`${process.env.REACT_APP_ASSETS_URL}/images/account/PublicCodeImage.png`}
      alt='Formulário do aluno com campo código de vínculo preenchido'
    />
  </Dialog>
)

export default ResponsibleLinkStudentModal
